import React from 'react';
import { PureTable } from 'src/pages/OfferPage/TableSvgOrganizer/PureTable';
import { CustomRowButton } from 'src/pages/OfferPage/TableSvgOrganizer/CustomRowButton';
import { TableHeader } from 'src/pages/OfferPage/TableSvgOrganizer/TableHeader';
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { Product } from "src/model/product.model";

export const NonRoomTable = (
    {
      projectId,
      tablesEnabled,
      table,
      roomMapsEnabled,
      detailsEnabled,
      dlStarted,
      infoButton = false,
      currency,
      dispatchDownloadStates,
      currentRowInEditing,
      setCurrentRowInEditing,
      labourCostEnabled = false,
      labourCost = null,
      measurementSystem,
      quoteUserProperties,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
      customItemsForRecommendation,
    }: {
      projectId: number;
      tablesEnabled: boolean;
      table: any;
      roomMapsEnabled: boolean;
      detailsEnabled: boolean;
      dlStarted: boolean;
      infoButton: boolean;
      currency: string;
      dispatchDownloadStates: any;
      currentRowInEditing: any;
      setCurrentRowInEditing: any;
      labourCostEnabled: boolean;
      labourCost: any;
      measurementSystem: string;
      quoteUserProperties: ProjectQuoteUserProperties;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
      customItemsForRecommendation: Product[];
    }
) => {

  const [customRowButtonPressed, setCustomRowButtonPressed] =
    React.useState(null);

  return table.entitytype === "projectcustomtable" &&
    !labourCostEnabled ? null : (
    <div className="break-before">
      <TableHeader
        tablesEnabled={tablesEnabled}
        table={table}
        guessed={table.guessed}
        roomMapsEnabled={roomMapsEnabled}
        infoButton={infoButton}
        measurementSystem={measurementSystem}
      />
      <PureTable
        projectId={projectId}
        table={table}
        detailsEnabled={detailsEnabled}
        tablesEnabled={tablesEnabled}
        dlStarted={dlStarted}
        guessed={table.guessed}
        customRowButtonPressed={customRowButtonPressed}
        setCustomRowButtonPressed={setCustomRowButtonPressed}
        currency={currency}
        dispatchDownloadStates={dispatchDownloadStates}
        icons={null}
        currentRowInEditing={currentRowInEditing}
        setCurrentRowInEditing={setCurrentRowInEditing}
        labourCost={labourCost}
        measurementSystem={measurementSystem}
        quoteUserProperties={quoteUserProperties}
        allManufacturerDiscountForProject={allManufacturerDiscountForProject}
        manufacturerRecommendationForProject={manufacturerRecommendationForProject}
        customItemsForRecommendation={customItemsForRecommendation}
      />
      {tablesEnabled &&
      table &&
      table.rows.length &&
      (table.entitytype === "projectcustomtable" ||
        table.entitytype === "functiontable" ||
        table.entitytype === "nhcdintable") ? (
        <CustomRowButton
          table={table}
          customRowButtonPressed={customRowButtonPressed}
          setCustomRowButtonPressed={setCustomRowButtonPressed}
          setCurrentRowInEditing={setCurrentRowInEditing}
        />
      ) : null}
    </div>
  );
};
